export function findOnePlugin(app) {
  const makeParams = (params = {}) => {
    return {
      ...params,
      query: {
        ...params.query,
        $limit: 1
      }
    };
  };

  const getResult = (result) => {
    let data = result.data || result;
    data = Array.isArray(data) ? data[0] : data;
    return data || null;
  };

  app.mixins.push(function (service) {
    service.findOne = function (params) {
      return service.find(makeParams(params)).then(getResult);
    };
  });
}

export function disablePaginationPlugin(app) {
  app.mixins.push(function (service) {
    const oldFind = service._find;

    if (!oldFind) {
      return;
    }

    service._find = async function (params) {
      if (params.paginate !== false) {
        return oldFind.call(service, params);
      }

      const $limit = params.query?.$limit;
      const $skip = params.query?.$skip || 0;

      const { total: initialTotal, data: initialData } = await oldFind.call(
        service,
        {
          ...params,
          query: {
            ...params.query,
            $skip: $skip || undefined,
            $limit: $limit || Number.MAX_SAFE_INTEGER
          }
        }
      );

      if (initialTotal === initialData.length) {
        return initialData;
      }

      if ($limit && $limit === initialData.length) {
        return initialData;
      }

      const total = $limit ? $limit : initialTotal;
      let remaining = total - initialData.length;
      const pageSize = initialData.length;
      const pages = Math.ceil(remaining / pageSize);
      const result = [...initialData];

      for (let page = 1; page <= pages; page++) {
        const pageSkip = $skip + pageSize * page;

        const { data: pageData } = await oldFind.call(service, {
          ...params,
          query: {
            ...params.query,
            $skip: pageSkip,
            $limit: remaining
          }
        });

        remaining = remaining - pageData.length;

        result.push(...pageData);
      }

      return result;
    };
  });
}
